<div class="price-details-tooltip" (click)="$event.stopPropagation()">
  <div class="tooltip-header">
    {{ 'quotations_and_orders.price_details_title' | translate }}
  </div>

  <div class="tooltip-body">
    <!-- System price row -->
    <div class="tooltip-row">
      <span class="row-label">{{ 'quotations_and_orders.system_price' | translate }}</span>
      <span class="row-value">{{ formatPrice(product.catalog_price) }}</span>
      <button
        *ngIf="!viewMode && !isSystemApplied && product.catalog_price != null"
        class="apply-btn"
        (click)="onApplySystemPrice($event)"
      >
        <ui-svg-icon svgIcon="rollback" size="small"></ui-svg-icon>
        {{ 'common.apply' | translate | uppercase }}
      </button>
    </div>

    <!-- AI parsed price row -->
    <div class="tooltip-row">
      <span class="row-label">
        {{ 'quotations_and_orders.parsed_data' | translate }}
        <ui-svg-icon svgIcon="ai-volta-icon" size="small"></ui-svg-icon>
      </span>
      <span class="row-value">{{ formatPrice(displayedParsedPrice) }}</span>
      <button
        *ngIf="!viewMode && !isAiApplied && product.ai_price != null"
        class="apply-btn"
        (click)="onApplyAiPrice($event)"
      >
        <ui-svg-icon svgIcon="rollback" size="small"></ui-svg-icon>
        {{ 'common.apply' | translate | uppercase }}
      </button>
    </div>
    <div class="tooltip-note" *ngIf="showConversionNote">
      {{ 'quotations_and_orders.side_by_side_panel.sub_unit_conversion_note' | translate }}
    </div>

    <!-- No price row -->
    <div class="tooltip-row">
      <span class="row-label">{{ 'quotations_and_orders.no_price_option' | translate }}</span>
      <span class="row-value">{{ formatPrice(null) }}</span>
      <button
        *ngIf="!viewMode && !isNoneApplied"
        class="apply-btn"
        (click)="onApplyNoPrice($event)"
      >
        <ui-svg-icon svgIcon="rollback" size="small"></ui-svg-icon>
        {{ 'common.apply' | translate | uppercase }}
      </button>
    </div>
  </div>

  <!-- Footer: current unit price + badge -->
  <div class="tooltip-footer">
    <span class="footer-label">{{ 'quotations_and_orders.order_line_columns.unit_price' | translate }}</span>
    <span class="footer-value">{{ isNoneApplied ? formatPrice(null) : formatPrice(product.final_price) }}</span>
    <span class="price-badge" [ngClass]="'badge-' + currentPriceType">
      <ui-svg-icon *ngIf="isAiApplied" svgIcon="ai-volta-icon" size="xsmall"></ui-svg-icon>
      <ng-container *ngIf="isSystemApplied">{{ 'quotations_and_orders.price_source_system' | translate }}</ng-container>
      <ng-container *ngIf="isAiApplied">{{ 'quotations_and_orders.price_source_ai' | translate }}</ng-container>
      <ng-container *ngIf="isOverrideApplied">{{ 'quotations_and_orders.price_source_override' | translate }}</ng-container>
      <ng-container *ngIf="isNoneApplied">{{ 'quotations_and_orders.price_source_none' | translate }}</ng-container>
    </span>
  </div>
</div>
